import styled from 'styled-components';

const CurrentLevelStyled = styled.h2`
  bottom: -30px;
  color: ${props => props.theme.colors.white};
  font-size: calc(${props => props.theme.fonts.baseSize} - 2px);
  font-weight: 800;
  left: 50%;
  letter-spacing: 3px;
  margin: 0;
  opacity: 0;
  position: absolute;
  text-transform: uppercase;
  transition: transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut},
    opacity ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeInOut};
  transition-delay: 1s;
  transform: translate(-50%, 0);

  span {
    background: ${props => props.theme.colors.quaternary};
    border-radius: 100%;
    color: ${props => props.theme.colors.tertiary};
    display: inline-block;
    height: 20px;
    letter-spacing: 0;
    line-height: 20px;
    padding: 0;
    text-align: center;
    width: 20px;
  }

  .game-wrap-enter-done & {
    opacity: 1;
    transform: translate(-50%, -50%);
  }

  @media screen and (min-wdith: ${props => props.theme.breakpoints.md}) {
  }
`;

export default CurrentLevelStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/CurrentLevel/CurrentLevel.styled.js